import ConflictBijzonderheidscodeGroup from './ConflictBijzonderheidscodeGroup';
import ConflictIcon from './ConflictIcon';
import ConflictIndicator from './ConflictIndicator';
import ConflictToelichting from './ConflictToelichting';
import VerkeerdMatAssigned from './VerkeerdMatAssigned';

type ConflictPartsType = {
  Toelichting: typeof ConflictToelichting;
  Icon: typeof ConflictIcon;
  Indicator: typeof ConflictIndicator;
  AssignedMat: typeof VerkeerdMatAssigned;
  OpvolgendeBijzonderheidscode: typeof ConflictBijzonderheidscodeGroup;
};
const ConflictParts: ConflictPartsType = {
  Toelichting: ConflictToelichting,
  Icon: ConflictIcon,
  Indicator: ConflictIndicator,
  AssignedMat: VerkeerdMatAssigned,
  OpvolgendeBijzonderheidscode: ConflictBijzonderheidscodeGroup,
};
export default ConflictParts;
